import { isInThisMonth, isInThisWeek } from '@/utils/commitmentDateFilters';

const PRIORITY_META = {
  high: {
    labelKey: 'UserProjects.overview.constraints.priority.high',
    dotClass: 'overview-constraint-priority--high',
  },
  medium: {
    labelKey: 'UserProjects.overview.constraints.priority.medium',
    dotClass: 'overview-constraint-priority--medium',
  },
  low: {
    labelKey: 'UserProjects.overview.constraints.priority.low',
    dotClass: 'overview-constraint-priority--low',
  },
};

function priorityResult(key) {
  const meta = PRIORITY_META[key] || PRIORITY_META.low;
  return { key, ...meta };
}

export function getConstraintPriority(constraint, now = new Date()) {
  const explicit = constraint?.priority;
  if (explicit === 'high' || explicit === 'medium' || explicit === 'low') {
    return priorityResult(explicit);
  }

  const dueDate = constraint?.dueDate;
  if (!dueDate) {
    return priorityResult('low');
  }

  const due = dueDate instanceof Date ? dueDate : new Date(dueDate);
  if (Number.isNaN(due.getTime())) {
    return priorityResult('low');
  }

  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const dueDay = new Date(due.getFullYear(), due.getMonth(), due.getDate());
  const days = Math.floor((dueDay.getTime() - today.getTime()) / (24 * 60 * 60 * 1000));

  if (days < 0) return priorityResult('high');
  if (days <= 7) return priorityResult('medium');
  return priorityResult('low');
}

export function constraintCardTitle(description) {
  const text = String(description || '').trim();
  if (!text) return '—';
  const firstLine = text.split('\n')[0];
  return firstLine.length > 120 ? `${firstLine.slice(0, 120)}…` : firstLine;
}

export function filterConstraintsByStatus(constraints, statusFilter) {
  if (!statusFilter || statusFilter === 'all') {
    return constraints;
  }
  return constraints.filter((item) => item.status === statusFilter);
}

export function filterConstraintsByZeitraum(constraints, zeitraum) {
  if (!zeitraum || zeitraum === 'all') {
    return constraints;
  }
  return constraints.filter((item) => {
    const created = item.date_created;
    if (zeitraum === 'thisWeek') return isInThisWeek(created);
    if (zeitraum === 'thisMonth') return isInThisMonth(created);
    return true;
  });
}

export function filterConstraintsByMilestone(constraints, milestoneId) {
  if (!milestoneId || milestoneId === 'all') {
    return constraints;
  }
  return constraints.filter(
    (item) => String(item.milestoneId) === String(milestoneId),
  );
}

export function filterConstraintsByOwner(constraints, ownerUserId) {
  if (!ownerUserId || ownerUserId === 'all') {
    return constraints;
  }
  return constraints.filter(
    (item) => String(item.ownerUserId) === String(ownerUserId),
  );
}

export function userInitials(name) {
  if (!name) return '?';
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }
  return String(name).slice(0, 2).toUpperCase();
}

export function formatConstraintDate(value) {
  if (!value) return '—';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString(undefined, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}
